import React, {Component} from "react";

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import {
    Card,
    Button,
    CardTitle,
    CardText,
    Row,
    Col,
    FormGroup,
    Label,
    Input,
} from 'reactstrap';

import {
    setCurrentSite
} from '../actions/login';

import Nav from '../components/nav/Nav';

import env from '../env';

class Home  extends Component{

    constructor(props) {

        super(props);

        this.state = {
            sites: [],
            site: null,
            loading: true
        };
    }

    componentDidMount(){

        const {sites, loggedIn} = this.props.account;

        let site = this.props.account.site;

        if(!loggedIn){
            this.props.history.push(`${env.url}/login`);
        }

        if(!site)
            site = sites[0];

        this.props.setCurrentSite({site});

        let loading = false;

        this.setState(
            {
                sites,
                site,
                loading
            });
    }

    /**
     * Change site
     *
     * @param e | event
     */
    changeSite = (e) => {

        let site = this.state.sites.filter((s) => s.id === parseInt(e.target.value, 10))[0];

        this.props.setCurrentSite({site});

        this.setState({site});
    };

    getIncidentForm = () => {

        const {site} = this.state;

        if(site){
            this.props.history.push(`${env.url}/incidents/form`);
        }

    };

    getDocuments = () => {

        const {site} = this.state;

        if(site){
            this.props.history.push(`${env.url}/documents/list`);
        }

    };


    getTaskForm = () => {

        const {site} = this.state;

        if(site){
            this.props.history.push(`${env.url}/tasks/form`);
        }

    };

    completeChecklists = () => {

        const {site} = this.state;

        if(site){
            this.props.history.push(`${env.url}/checklists/list`);
        }

    };

    viewChecklists = () => {
        const {site} = this.state;

        if(site){
            this.props.history.push(`${env.url}/checklists/completed`);
        }
    };

    viewRisks = () => {

        const {site} = this.state;

        if(site){
            this.props.history.push(`${env.url}/risks/list`);
        }

    };

    getRiskForm = () => {

        const {site} = this.state;

        if(site){
            this.props.history.push(`${env.url}/risks/form`);
        }

    };

    render(){

        const {
            sites,
            loading,
            site
        } = this.state;

        return(
            <div className="elint-home">

                <Nav
                    location={this.props.location}
                    history={this.props.history}/>

                {
                    loading?
                        null
                        :
                        <div className="links-holder">
                            <Row>
                                <Col>
                                    <FormGroup>
                                        <Label for="site">Select a Site</Label>
                                        <Input
                                            type="select"
                                            name="site"
                                            id="site"
                                            value={site? site.id: ''}
                                            onChange={this.changeSite}>
                                            {
                                                sites.map(site => (
                                                    <option key={site.id} value={site.id}>
                                                        {site.name}
                                                    </option>
                                                ))
                                            }
                                        </Input>
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Card body inverse color="primary">
                                        <CardTitle>
                                            Continual Improvements
                                        </CardTitle>
                                        <CardText style={{'textAlign': 'center'}}>
                                            Report a Continual Improvement for <br/><strong>{site? site.name: ''}</strong>
                                        </CardText>
                                        <Button
                                            disabled={loading}
                                            color="secondary"
                                            onClick={this.getIncidentForm}>
                                            Report
                                        </Button>
                                    </Card>
                                </Col>
                                <Col>
                                    <Card body inverse color="success">
                                        <CardTitle>
                                            Checklists
                                        </CardTitle>
                                        <CardText style={{'textAlign': 'center'}}>
                                            All CheckLists for <br/><strong>{site? site.name: ''}</strong>.
                                        </CardText>
                                        <Row>
                                            <Col>
                                                <Button
                                                    style={{width: '100%'}}
                                                    color="secondary"
                                                    disabled={loading}
                                                    onClick={this.completeChecklists}>
                                                    Complete
                                                </Button>
                                            </Col>
                                            <Col>
                                                <Button
                                                    style={{width: '100%'}}
                                                    color="secondary"
                                                    disabled={loading}
                                                    onClick={this.viewChecklists}>
                                                    View
                                                </Button>
                                            </Col>
                                        </Row>
                                    </Card>
                                </Col>
                            </Row>

                            <Row>
                                <Col>
                                    <Card body inverse color="warning">
                                        <CardTitle>
                                            Task
                                        </CardTitle>
                                        <CardText style={{'textAlign': 'center'}}>
                                            Report a Task for <br/><strong>{site? site.name: ''}</strong>
                                        </CardText>
                                        <Button
                                            disabled={loading}
                                            color="secondary"
                                            onClick={this.getTaskForm}>
                                            Add Task
                                        </Button>
                                    </Card>
                                </Col>
                                <Col>
                                    <Card body inverse color="danger">
                                        <CardTitle>
                                            Risk Assessment
                                        </CardTitle>
                                        <CardText style={{'textAlign': 'center'}}>
                                            Conduct a risk assessment for <br/> <strong>{site? site.name: ''}</strong>.
                                        </CardText>
                                        <Row>
                                            <Col>
                                                <Button
                                                    style={{width: '100%'}}
                                                    color="secondary"
                                                    disabled={loading}
                                                    onClick={this.getRiskForm}>
                                                    Complete
                                                </Button>
                                            </Col>
                                            <Col>
                                                <Button
                                                    style={{width: '100%'}}
                                                    color="secondary"
                                                    disabled={loading}
                                                    onClick={this.viewRisks}>
                                                    View
                                                </Button>
                                            </Col>
                                        </Row>

                                    </Card>
                                </Col>
                            </Row>
                            <Row>
                                <Col sm={1} md={6}>
                                    <Card body inverse color="primary">
                                        <CardTitle>
                                            Documents
                                        </CardTitle>
                                        <CardText style={{'textAlign': 'center'}}>
                                            View/Download documents for <br/><strong>{site? site.name: ''}</strong>
                                        </CardText>
                                        <Button
                                            disabled={loading}
                                            color="secondary"
                                            onClick={this.getDocuments}>
                                            View
                                        </Button>
                                    </Card>
                                </Col>
                            </Row>
                        </div>
                }
            </div>
        )
    }
}


const mapStateToProps = ({ account }) => ({
    account: account,
});

const mapDispatchToProps = dispatch => bindActionCreators({
    setCurrentSite: (data) => setCurrentSite(data)
}, dispatch);

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Home)



// WEBPACK FOOTER //
// ./src/screens/Home.js